import { forwardRef, FunctionComponent, PropsWithoutRef, Ref } from 'react';
import styled, { css } from 'styled-components';

import { defaultThemeProp } from '../../../theme';
import { StyledFormControl } from '../../FormControl';
import Flex from '../../Flex';
import { ForwardProps } from '../../../types';
import { StyledSelectInput } from '../ComboBox.styles';

import SingleSelectInputProps from './SingleSelectInput.types';

export const StyledSingleSelectInput = styled(StyledSelectInput)``;

const StyledVisualContainer = styled.span(props => {
  const {
    theme: {
      base,
      components: {
        'form-control': formControl,
        input: { height }
      }
    }
  } = props;

  return css`
    border-inline-end: ${formControl['border-width']} solid ${formControl['border-color']};
    min-width: calc(${height} - ${formControl['border-width']});
    padding: 0 calc(0.5 * ${base.spacing});
    height: calc(${height} - 2 * ${formControl['border-width']});
  `;
});

StyledVisualContainer.defaultProps = defaultThemeProp;

const SingleSelectInput: FunctionComponent<SingleSelectInputProps & ForwardProps> = forwardRef(
  (props: PropsWithoutRef<SingleSelectInputProps>, ref: Ref<HTMLInputElement>) => {
    const { value, readOnly, disabled, status, actions, onChange, selected, visual, ...restProps } =
      props;

    return (
      <Flex
        as={StyledSingleSelectInput}
        forwardedAs={StyledFormControl}
        container={{ alignItems: 'center', wrap: 'nowrap' }}
        {...{
          disabled,
          status,
          readOnly
        }}
      >
        {visual && (
          <Flex container={{ justify: 'center', alignItems: 'center' }} as={StyledVisualContainer}>
            {visual}
          </Flex>
        )}
        <input
          {...{
            ref,
            disabled,
            status,
            readOnly
          }}
          value={value || selected?.text || ''}
          // no-op avoids react uncontrolled warning
          onChange={onChange || (() => {})}
          readOnly={readOnly || !onChange}
          autoComplete='off'
          {...restProps}
        />
        {actions}
      </Flex>
    );
  }
);

export default SingleSelectInput;
